import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContractorService {
  apiUrl: string = environment.API_SERVER;
  lotId: any;
  biddingStageId: any;
  tenderInfo: any;
  amount: any;
  shortListedLot: any;
  constructor(private _httpClient: HttpClient) {}

  createTenderPayment(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-tender-payment/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`,
      payload.body
    );
  }
  getAllAdvertisementItem(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-advert/get-all-procurement-adverts/`,
      { params: payload.params }
    );
  }
  getTenderAmount(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/configurations/${payload.configurationId}/`
    );
  }
  getAdvertLot(payload): Observable<any> {
    return this._httpClient.get(`${this.apiUrl}/lot/get-lot/${payload.lotId}`);
  }
  getAdvertisementLot(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-advert-lot/get-procurement-advert-lot/${payload.procAdvertId}/${payload.lotId}`
    );
  }
  deleteAdvertisementItem(payload): Observable<any> {
    return this._httpClient.delete(
      `${this.apiUrl}/procurement-advert/delete-procurement-advert/${payload.procurementAdvertId}`
    );
  }
  updateAdvertisementItem(payload): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/procurement-advert/edit-procurement-advert/${payload.procurementAdvertId}`,
      payload.body
    );
  }
  getAllAdvertisementlot(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-advert-lot/get-all-procurement-advert-lots/`,
      { params: payload.params }
    );
  }
  getProcurementCycle(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/proc-cycles/get-all-proc-cylces/`,
      { params: payload.params }
    );
  }
  deleteAdvertLot(payload): Observable<any> {
    return this._httpClient.delete(
      `${this.apiUrl}/procurement-advert-lot/delete-procurement-advert-lot/${payload.procurementAdvertId}`
    );
  }
  getAllAdvertisementDocument(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-advert-doc/get-all-procurement-advert-docs/`,
      { params: payload.params }
    );
  }
  deleteLotDocument(payload): Observable<any> {
    return this._httpClient.delete(
      `${this.apiUrl}/procurement-advert-doc/delete-procurement-advert-doc/${payload.procAdvertDocId}`
    );
  }
}
